// extracted by mini-css-extract-plugin
module.exports = {"OnlinePlatformsSettings":"OnlinePlatformsSettings___1Miuk","preference_row":"preference_row___3p5TI"};